import { jsx as t } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { TX_DATA_CONTAINER as r } from "../constants.js";
import s from "classnames";
const n = ({ children: a, className: o }) => /* @__PURE__ */ t("div", { className: s(r, o), children: a });
export {
  n as default
};
